import pallet from 'constants/colors';

export default {
  action: {
    flex: '1 1 0',
    justifyContent: 'center',
    minHeight: 40,
    maxHeight: 40,
  },
  actionButton: {
    maxWidth: 'none',
    fontSize: 14,
  },
  time: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  containerItem: {
    flex: 1,
    margin: 12,
    minWidth: 350,
  },
  title: {
    margin: 0,
    textAlign: 'center',
  },
  subtitle: {
    display: 'block',
    textAlign: 'center',
    marginLeft: 0,
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 32,
    paddingBottom: 16,
  },
  paper: {
    padding: 16,
  },
  chart: {
    width: '70%',
    height: 24,
    borderRadius: 4,
    overflow: 'hidden',
    marginTop: 12,

    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: '#eeeeee',
  },
  chartBar: {
    height: '100%',
    backgroundColor: pallet.primary3Color,
  },
  mainValueContainer: {
    padding: 24,
    paddingTop: 12,
  },
  mainValue: {
    fontSize: 24,
    textAlign: 'center',
  },
  subtitleValue: {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    textAlign: 'center',
    marginTop: 12,
  },
};



// WEBPACK FOOTER //
// ./src/styles/HolidayEntry.js